import React from "react";
import "./ComponentResultsWithIMG.css";
import ChangeLink from "../../../../../Elements/ChangeLink/ChangeLink";
import {MonthToText} from "../../../../../../AdminPart/src/Constants";
const PRERENDER_TEXTS = require("../../../../../../prerender_base.js");

function DateToContestView(myDate,lang) {
    const myDateArray = myDate.split('-')
    return myDateArray[2] + ' ' + MonthToText(myDateArray[1],lang) + ' ' + myDateArray[0];
}

function ContestsToSmallFormatWeNeed(ContestItog,data, lang) {
    try {
        return ContestItog.map(
            function (Contest,i) {
                return <div key={i} className="ComponentResultSmallElement" >
                    <div className={"ComponentResultSmallTD01 ComponentResultSmallTD01"+Contest.ContestName}/>
                    <ChangeLink lang={lang} to={`/trader/contests/resultdetail/?contest=`+Contest.ContestName+'&date='+Contest.ContestDate} style={{textDecoration: 'none'}}>
                        <div className="ComponentResultSmallTD02">
                            <div className="ComponentResultSmallTD02Title">
                                {data['ContestTypes0000'] ? JSON.parse(data['ContestTypes0000'])[lang]  : '*Конкурс'}
                                <span className="StandartSpace"/>
                                "{Contest.ContestName}"
                            </div>
                            <div className="ComponentResultSmallTD03">

                            <div className="ComponentResultSmallTD03Time">{DateToContestView(Contest.ContestDate, lang)}</div>
                            <div className="ComponentResultSmallTD03Prize">{data['ContestTypes0005'] ? JSON.parse(data['ContestTypes0005'])[lang] : '*Приз: '} {Contest.ContestWin}$</div>
                            </div>
                        </div>
                    </ChangeLink>
                </div>
            }
        );
    } catch (e) {
        //console.log(e);
    }

}

    function ComponentResultsWithIMG(props) {
        return (
            <div className="ComponentResultSmall">
                {ContestsToSmallFormatWeNeed(props.AllResults, PRERENDER_TEXTS["ContestTypes"], props.lang)}
            </div>
        )}

export default ComponentResultsWithIMG

